module.exports = __webpack_public_path__ + "img/garruk.a0ae5597.jpg";